import { useParams } from 'react-router-dom';
import styles from './Settings.module.css';

export function SettingsPage() {
    const { clientId } = useParams<{ clientId: string }>();

    return (
        <div className={styles.container}>
            <header className={styles.header}>
                <h1>⚙️ Settings</h1>
                <p>Pengaturan toko dan akun</p>
            </header>

            <div className={styles.section}>
                <h2>Informasi Toko</h2>
                <div className={styles.formGroup}>
                    <label>Nama Toko</label>
                    <input type="text" placeholder="Nama toko Anda" disabled />
                </div>
                <div className={styles.formGroup}>
                    <label>Client ID</label>
                    <input type="text" value={clientId || ''} disabled />
                </div>
                <div className={styles.formGroup}>
                    <label>Email</label>
                    <input type="email" placeholder="email@example.com" disabled />
                </div>
            </div>

            <div className={styles.section}>
                <h2>Keamanan</h2>
                <div className={styles.formGroup}>
                    <label>Password Baru</label>
                    <input type="password" placeholder="••••••••" disabled />
                </div>
                <div className={styles.formGroup}>
                    <label>Konfirmasi Password</label>
                    <input type="password" placeholder="••••••••" disabled />
                </div>
            </div>

            <div className={styles.section}>
                <h2>Kiosk URL</h2>
                <div className={styles.kioskUrl}>
                    <input type="text" value={`${window.location.origin}/k/${clientId}`} readOnly />
                    <button onClick={() => navigator.clipboard.writeText(`${window.location.origin}/k/${clientId}`)}>
                        📋 Copy
                    </button>
                </div>
                <p className={styles.hint}>Bagikan URL ini ke pelanggan untuk akses Kiosk ScentMatch</p>
            </div>

            <div className={styles.comingSoon}>
                <p>🚧 Fitur lengkap Settings akan segera hadir</p>
            </div>
        </div>
    );
}
